// extracted by mini-css-extract-plugin
export default {"LookDom":"LookDom_LookDom__oSGKv"};